import React from 'react';
import {
    Form, Input, Select, Switch, DatePicker,Icon, InputNumber
} from 'antd';
import { StyledInputNumber } from '../../productos/style';
const { TextArea } = Input;


export const InputField = ({ input, label, type, ph, meta: { touched, error } }) => (
    <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={<span style={{ color: "#000000" }}>{ph}</span>}
        validateStatus={touched && error ? "error" : ""}
        hasFeedback
        help={touched && error ? error : ""} >
        <Input
            placeholder={ph}
            onChange={input.onChange}
            value={input.value}
            size={"default"}
            onBlur={input.onBlur}
        />
    </Form.Item>
)

export const InputTypeNumber = ({ input, label, type, ph, meta: { touched, error } }) => (
    <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={<span style={{ color: "#000000" }}>{ph}</span>}
        validateStatus={touched && error ? "error" : ""}
        hasFeedback
        help={touched && error ? error : ""} >
        <Input
            placeholder={ph}
            onChange={input.onChange}
            value={input.value}
            type="number"
            size={"default"}
            onBlur={input.onBlur}
        />
    </Form.Item>
)

export const InputTypePrice = ({ input, label, type, ph, meta: { touched, error } }) => (
    <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={<span style={{ color: "#000000" }}>{ph}</span>}
        validateStatus={touched && error ? "error" : ""}
        hasFeedback
        help={touched && error ? error : ""} >
        <StyledInputNumber
            placeholder={ph}
            onChange={input.onChange}
            value={input.value}
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            //type="number"
            size={"large"}
            //onBlur={input.onBlur}
        />
    </Form.Item>
)


export const FieldPassword = props => {
    return(
        <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={<span style={{ color: "#000000" }}>{props.ph}</span>}
            validateStatus={props.meta.touched && props.meta.error ? "error" : ""}
            hasFeedback
            help={props.meta.touched && props.meta.error ? props.meta.error : ""}
        >
            <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,)' }} />}
                type="password"
                placeholder="contraseña"
                onChange={props.input.onChange}
                value={props.input.value}
                size={"default"}
                allowClear={true}
            />
        </Form.Item>
    )
  }

export const textArea = ({ input, label, type, ph, meta: { touched, error } }) => (
    <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={<span style={{ color: "#000000" }}>{ph}</span>}
        validateStatus={touched && error ? "error" : ""}
        hasFeedback
        help={touched && error ? error : ""} >
        <TextArea
            autoSize={{ minRows: 5, maxRows:10 }}
            placeholder={ph}
            onChange={input.onChange}
            value={input.value}
            onBlur={input.onBlur}
        />
    </Form.Item>
)
export const checkBox = ({ ph, input }) => {
    return (
        <Form.Item
            labelCol={{ span: 9 }}
            wrapperCol={{ span: 3 }}
            label={<span style={{ color: "#000000" }}>{ph}</span>}
        >
            <Switch onChange={(checked) => input.onChange(checked)} />
        </Form.Item>
    );
};
export const FieldSelectMultiple = props => {
    return (
        <Form.Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 15 }}
            label={<span style={{ color: "#000000" }}>{props.ph}</span>}
            validateStatus={props.meta.touched && props.meta.error ? "error" : ""}
            hasFeedback
            help={props.meta.touched && props.meta.error ? props.meta.error : ""} >
            <Select
                mode="multiple"
                placeholder={props.ph}
                onChange={props.input.onChange}
                onBlur={() => {
                    props.input.onBlur(props.input.value)
                }}
                size="default"
            >
                {props.children}

            </Select>

        </Form.Item>)
}


export const FieldSelectRegistro = props => {
    return (
        <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={<span style={{ color: "#000000" }}>{props.ph}</span>}
            validateStatus={props.meta.touched && props.meta.error ? "error" : ""}
            hasFeedback
            help={props.meta.touched && props.meta.error ? props.meta.error : ""} >
            <Select
                mode="multiple"
                placeholder={props.ph}
                onChange={props.input.onChange}
                onBlur={() => {
                    props.input.onBlur(props.input.value)
                }}
                size="default"

            >
                {props.children}

            </Select>

        </Form.Item>)
}

export const FieldSelectRegistroCategoria = props => {
    return (
        <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={<span style={{ color: "#000000" }}>{props.ph}</span>}
            validateStatus={props.meta.touched && props.meta.error ? "error" : ""}
            hasFeedback
            help={props.meta.touched && props.meta.error ? props.meta.error : ""} >
            <Select
                mode="multiple"
                placeholder={props.ph}
                onChange={props.input.onChange}
                onBlur={() => {
                    props.input.onBlur(props.input.value)
                }}
                size="default"
                filterOption={(input, option) =>
                    option.props.children.indexOf(input.toUpperCase()) >= 0
                }
            >
                {props.children}

            </Select>

        </Form.Item>)
}

export const FieldSelectEditar = props => {
        let permisos= props.defaultVal.map(function(x) {
              return x.id
          })
    return (
        <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={<span style={{ color: "#000000" }}>{props.ph}</span>}
            validateStatus={props.meta.touched && props.meta.error ? "error" : ""}
            hasFeedback
            help={props.meta.touched && props.meta.error ? props.meta.error : ""} >
            <Select
                mode="multiple"
                showSearch
                placeholder={props.ph}
                onChange={props.input.onChange}
                onBlur={() => {
                    props.input.onBlur(props.input.value)
                }}
                size="default"
                filterOption={(input, option) =>
                    option.props.children.indexOf(input.toUpperCase()) >= 0
                }
                defaultValue={permisos}
            >
                {props.children}

            </Select>

        </Form.Item>)
}

export const FieldSelectNormalEditar = props => {
    //console.log(props.input.value)
return (
    <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={<span style={{ color: "#000000" }}>{props.ph}</span>}
        validateStatus={props.meta.touched && props.meta.error ? "error" : ""}
        hasFeedback
        help={props.meta.touched && props.meta.error ? props.meta.error : ""} >
        <Select
            placeholder={props.ph}
            onChange={props.input.onChange}
            onBlur={() => {
                props.input.onBlur(props.input.value)
            }}
            size="default"
            value={props.input.value}
        >
            {props.children}

        </Select>

    </Form.Item>)
}


export const InputCalendar = ({ input, label, type, ph, meta: { touched, error } }) => (
    <Form.Item
        labelCol={{ span: 9 }}
        wrapperCol={{ span: 7 }}
        label={<span style={{ color: "#000000" }}>{ph}</span>}
        validateStatus={touched && error ? "error" : ""}
        hasFeedback
        help={touched && error ? error : ""} >
        <DatePicker onChange={(date, dateString) => input.onChange(dateString)} />

    </Form.Item>
)


export const required = value => (value || typeof value === 'number' ? undefined : 'Campo requerido')

export const maxLength = max => value =>
  value && value.length > max ? `El campo dede ser menor a ${max} caracteres` : undefined
export const minLength = min => value =>
  value && value.length < min ? `El campo debe ser mayor a ${min} caracteres` : undefined
export const minLength2 = minLength(5)

export const number = value =>
  value && isNaN(Number(value)) ? 'El campo debe ser un numero' : undefined
export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Direccion de correo invalida'
    : undefined
export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Numero invalido de telefono debe ser de 10 digitos'
    : undefined

